<template>
    <div class="componentTextResume">
        <div class="title">
            <i class="fa-solid fa-hand-point-up"></i>
            <h4>
                {{title}} <br>
                <b>{{ numberSpacing(value) }} {{ label }}</b>
            </h4>
        </div>
        <p v-html="$t('dash.reporting.pdf.textResume.text').replace('%s',
            `<b>${pourcentage >= 0 ? 'augmentation' : 'diminution'}</b>`).replace('%p',
            `<span class='value'>${pourcentage}%</span><br>`
        ) + ` <b>${DateStart.toLocaleString('fr-FR', { year: 'numeric', month: 'long', day: 'numeric' })} - 
            ${DateEnd.toLocaleString('fr-FR', { year: 'numeric', month: 'long', day: 'numeric' })}</b>`"></p>
    </div>
</template>

<script>
    export default {
        props: {
            value: String,
            title: String,
            label: String,
            pourcentage: Number,
            DateStart: Date,
            DateEnd: Date,
        },

        methods: {
            numberSpacing(number) {
                return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
             
            }
        },
    }
</script>
